export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, viewport-fit=cover"},{"charset":"utf-8"},{"name":"naver-site-verification","content":"92147456aa9eb682c93b06a2212399c984166a26"}],"link":[{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/background/background_home.png"},{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/skeleton/home/line-chart.png"},{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/skeleton/home/block-chain.png"},{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/skeleton/home/info.png"},{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/skeleton/home/pie-chart.png"},{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/skeleton/home/progress-bar.png"},{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/skeleton/home/three-bar-chart.png"},{"rel":"preload","as":"image","href":"https://globalstatic.xangle.io/explorer/nexon/skeleton/home/two-line-chart.png"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"(function(c,l,a,r,i,t,y){\n        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n        t=l.createElement(r);t.async=1;t.src=\"https://www.clarity.ms/tag/\"+i;\n        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n    })(window, document, \"clarity\", \"script\", \"qwl9sddu53\");\n"}],"noscript":[],"viewport":"width=device-width, initial-scale=1, minimum-scale=1, viewport-fit=cover"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000